import {get, post} from '@/network/request.js';


export const articleList = p => get('/general/article', p);
export const articleDetail = p => get('/general/article/' + p, {})

export const voteCategory = p => get('votes/category', p)
export const voteList = p => get('votes/index', p)
export const voteDetail = p => get('votes/index/' + p + '?subject_id=1', {})

export const submitForm = p => post('profile/opusPC', p)


// WEBPACK FOOTER //
// ./src/network/API.js